<template>
  <div class="page">
    <div class="container">
      <div class="mall-part">
        <!-- 导航栏 -->
        <div class="nav-bar">
          <div class="nav-title">
            <!-- <span @click="backHome" code-stm="event, PAGEURL, 返回首页">首页</span>
             >  -->
            <span @click="backHome" code-stm="event, PAGEURL, 返回品牌商城">品牌商城</span>
             >
            <span>{{ productDetail.productName || "商品详情" }}</span>
          </div>
        </div>

        <!-- 商品参数模块 -->
        <div class="product-info-section" v-loading="isLoading">
          <div class="product-info-wrapper">
            <!-- 左侧：商品图片 -->
            <div class="product-image-section">
              <div class="main-image">
                <img
                  :src="currentImage || productDetail.mainImage"
                  :alt="productDetail.productName"
                />
              </div>
              <!-- 缩略图列表 -->
              <div class="thumbnail-list" v-if="imageList.length > 1">
                <div
                  v-for="(img, index) in imageList"
                  :key="index"
                  class="thumbnail-item"
                  :class="{ active: currentImage === img }"
                  @click="currentImage = img"
                   code-stm="event, PAGEURL, 点击查看放大图片"
                >
                  <img :src="img" :alt="`缩略图${index + 1}`" />
                </div>
              </div>
            </div>

            <!-- 右侧：商品信息 -->
            <div class="product-info-content">
              <div class="product-name">{{ productDetail.productName }}</div>

              <!-- 价格信息 -->
              <div class="product-price-section">
                <div class="price-item">
                  <img
                    :src="
                      preText +
                      '/assets/~/media/images/activity/kiamall/pc/mall-icon-jifen.png'
                    "
                    alt="积分"
                  />
                  <!-- <span class="price-label">积分：</span> -->
                  <span class="price-value">{{
                    formatPoints(productDetail.pricePoints)
                  }}</span>
                </div>
                <div class="price-item">
                  <img
                    :src="
                      preText +
                      '/assets/~/media/images/activity/kiamall/pc/mall-icon-money.png'
                    "
                    alt="金额"
                  />
                  <!-- <span class="price-label">金额：</span> -->
                  <span class="price-value">{{
                    formatCash(productDetail.priceCash)
                  }}</span>
                </div>
              </div>
              <div class="product-price-section">
                <div class="price-item">
                  <span class="price-label">规格：</span>
                  <span class="price-value">{{
                    formatPoints(productDetail.specifications)
                  }}</span>
                </div>
              </div>

              <!-- 规格选择 -->
              <div class="product-spec-section" v-if="specList.length > 0">
                <div
                  v-for="(spec, index) in specList"
                  :key="index"
                  class="spec-item"
                >
                  <div class="spec-label">{{ spec.specName }}：</div>
                  <div class="spec-options">
                    <span
                      v-for="(option, optIndex) in spec.options"
                      :key="optIndex"
                      class="spec-option"
                      :class="{
                        active: selectedSpecs[spec.specName] === option,
                      }"
                      @click="selectSpec(spec.specName, option)"
                    >
                      {{ option }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- 立即购买按钮 -->
              <div
                class="product-action"
                @mouseenter="showCodePopupTop = true"
                @mouseleave="showCodePopupTop = false"
              >
                <el-button
                  type="primary"
                  class="buy-btn"
                  @click="handleBuy"
                  :disabled="!canBuy"
                  code-stm="event, PAGEURL, 立即购买"
                >
                  立即购买
                </el-button>
                <!-- 二维码弹窗 -->
                <div
                  class="code-popup"
                  v-show="showCodePopupTop"
                  :style="{
                    backgroundImage: `url(${preText}/assets/~/media/images/activity/kiamall/pc/mall-code-bg.png)`
                  }"
                >
                  <div class="code-content">
                    <img
                      :src="qrCodeUrl || productDetail.qrCode || productDetail.codeImage"
                      alt="二维码"
                      class="code-image"
                    />
                    <div class="code-text">打开kia App 扫码购买</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 商品详情模块 -->
        <div class="product-detail-section">
          <div class="detail-title">商品详情</div>
          <div
            class="detail-content"
            v-html="productDetail.productDetail || productDetail.detail"
          ></div>
          <!-- PC端详情右下角购买按钮 -->
          <div
            class="detail-buy-btn-wrapper"
            :class="{
              'detail-buy-btn-wrapper--fixed': isMobile && !isButtonAbsolute,
              'detail-buy-btn-wrapper--absolute': isMobile && isButtonAbsolute,
            }"
          >
            <div
              class="detail-product-action"
              @mouseenter="showCodePopupDetail = true"
              @mouseleave="showCodePopupDetail = false"
            >
              <!-- 返回按钮（移动端） -->
              <!-- <el-button
               v-if="isMobile"
                class="detail-back-btn"
                @click="goBack"
                title="返回"
                aria-label="返回"
                code-stm="event, PAGEURL, 返回mob"
              >
                <i class="el-icon-arrow-left"></i>
              </el-button> -->
              <el-button
                type="primary"
                class="detail-buy-btn"
                @click="handleBuy"
                :disabled="!canBuy"
                code-stm="event, PAGEURL, 立即购买mob"
              >
                立即购买
              </el-button>
              <!-- 二维码弹窗 -->
              <div
                v-show="showCodePopupDetail && !isMobile"
                class="detail-code-popup"
                :style="{
                  backgroundImage: `url(${preText}/assets/~/media/images/activity/kiamall/pc/mall-code-bg.png)`
                }"
              >
                <div class="detail-code-content">
                  <img
                    :src="qrCodeUrl || productDetail.qrCode || productDetail.codeImage"
                    alt="二维码"
                    class="detail-code-image"
                  />
                  <div class="detail-code-text">打开kia App 扫码购买</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queUrl } from "@/config/base";

export default {
  name: "mallDetail",
  components: {
  },
  data() {
    const ua = navigator.userAgent || "";
    const initialIsMobile =
      window.innerWidth <= 768 || /Mobile|Android|iP(hone|od|ad)/i.test(ua);
    return {
      productId: "",
      productDetail: {},
      isLoading: false,
      headers: {},
      preText: "https://www.kia.cn",
      isMobile: initialIsMobile,
      currentImage: "",
      imageList: [],
      specList: [],
      selectedSpecs: {},
      showCodePopupTop: false,
      showCodePopupDetail: false,
      qrCodeUrl: "", // 生成的二维码URL
      // 移动端：底部购买按钮滚动到 Footer 时改为 absolute，避免遮挡
      isButtonAbsolute: false,
    };
  },
  computed: {
    canBuy() {
      // 检查是否可以选择购买（例如：是否有库存、是否选择了必选规格等）
      return true;
    },
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    // 判断是否为移动端
    const ua = navigator.userAgent || "";
    this.isMobile =
      window.innerWidth <= 768 ||
      /Mobile|Android|iP(hone|od|ad)/i.test(ua);

    // 移动端：监听滚动，参考 recommend.vue 的吸底按钮逻辑
    if (this.isMobile) {
      window.addEventListener("scroll", this.handleBuyButtonScroll, { passive: true });
      this.$nextTick(() => {
        this.handleBuyButtonScroll();
      });
    }

    // 获取URL参数
    this.productId = this.$route.query.id || this.$route.params.id || "";

    // 初始化 headers
    this.headers = {
      Token: "a5764a961abc48e28067bd5a8b69c61e", // 测试token，实际应该从登录信息获取
    };

    if (this.productId) {
      // 获取商品详情
      this.getProductDetail();
    } else {
      this.$message.error("商品ID不能为空");
    }
  },
  beforeDestroy() {
    if (this.isMobile) {
      window.removeEventListener("scroll", this.handleBuyButtonScroll);
    }
  },
  methods: {
    goBack() {
      if (this.$router && typeof this.$router.back === "function") {
        this.$router.back();
      } else if (this.$router && typeof this.$router.go === "function") {
        this.$router.go(-1);
      }
    },
    backHome() {
      // 关闭所有历史页面，跳转到首页
      this.$router.replace({ path: '/' });
    },
    backList() {
      // 关闭所有历史页面，跳转到 mallList
      this.$router.replace({ path: '/mallList' });
    },
    // 监听页面滚动：当 Footer 进入视口时，移动端按钮由 fixed 变为 absolute，避免压住 Footer
    handleBuyButtonScroll() {
      if (!this.isMobile) return;
      try {
        const footer = document.getElementById("page1");
        if (!footer || typeof footer.getBoundingClientRect !== "function") {
          this.isButtonAbsolute = false;
          return;
        }
        const rect = footer.getBoundingClientRect();
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight || 0;
        // 关键：判断“Footer 是否会被吸底按钮遮挡”，而不是“Footer 是否进入视口”
        // 吸底按钮高度（拿不到时给一个兜底值，避免初始化误判）
        const buyBarEl =
          (this.$el && this.$el.querySelector && this.$el.querySelector(".detail-buy-btn-wrapper")) ||
          null;
        const buyBarHeight =
          (buyBarEl && buyBarEl.getBoundingClientRect && buyBarEl.getBoundingClientRect().height) ||
          0;
        const safePadding = 8; // 预留一点间距，避免临界抖动
        this.isButtonAbsolute = rect.top <= viewportHeight - safePadding;
      } catch (e) {
        this.isButtonAbsolute = false;
      }
    },
    // Header-co 会 emit forbid/open；这里做兜底，避免触发时报错
    forbid() {},
    open() {},
    // 获取商品详情
    getProductDetail() {
      if (!this.productId) {
        this.$message.error("商品ID不能为空");
        return;
      }

      this.isLoading = true;

      this.$axios
        .get(`${queUrl}api/shop/product/getAPIInfo/${this.productId}`, {
          headers: this.headers,
        })
        .then((res) => {
          console.log("商品详情:", res);
          if (res.data.code == 200) {
            this.productDetail = res.data.data || res.data.rows || {};
            // 处理商品图片列表
            this.initImageList();
            // 处理规格列表
            this.initSpecList();
            // 生成二维码
            this.generateQRCode();
          } else {
            this.$message.error(res.data.message || "获取商品详情失败");
          }
        })
        .catch((err) => {
          console.error("获取商品详情失败:", err);
          this.$message.error("获取商品详情失败");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 初始化图片列表
    initImageList() {
      const images = [];
      // 主图
      if (this.productDetail.mainImage) {
        images.push(this.productDetail.mainImage);
      }
      // 其他图片（根据实际接口字段调整）
      if (this.productDetail.imageList && Array.isArray(this.productDetail.imageList)) {
        images.push(...this.productDetail.imageList);
      } else if (this.productDetail.images) {
        const imgArray = Array.isArray(this.productDetail.images)
          ? this.productDetail.images
          : this.productDetail.images.split(",");
        images.push(...imgArray);
      }
      this.imageList = images.filter((img) => img);
      this.currentImage = this.imageList[0] || "";
    },
    // 初始化规格列表
    initSpecList() {
      // 根据实际接口返回的规格数据结构调整
      if (this.productDetail.specList && Array.isArray(this.productDetail.specList)) {
        this.specList = this.productDetail.specList;
      } else if (this.productDetail.specs) {
        // 如果规格是字符串或其他格式，需要解析
        this.specList = [];
      }
    },
    // 选择规格
    selectSpec(specName, option) {
      this.$set(this.selectedSpecs, specName, option);
    },
    // 立即购买
    handleBuy() {
      // 移动端：直接跳转到接口返回的商品链接
      if (this.isMobile) {
        const productLink =
          this.productDetail.productLink ||
          this.productDetail.link ||
          "";
        if (productLink) {
          window.location.href = productLink;
        } else {
          this.$message.error("暂未配置商品链接");
        }
        return;
      }

      // PC 端：仍通过二维码购买，这里不直接跳转
      // 可按需补充 PC 端逻辑
    },
    // 千分位格式化
    formatThousand(value, keepDecimals = false) {
      if (value === null || value === undefined || value === "") {
        return keepDecimals ? "0.00" : "0";
      }
      const num = Number(value);
      if (isNaN(num)) {
        return String(value);
      }
      const fixedStr = keepDecimals
        ? num.toFixed(2)
        : Math.floor(num).toString();
      const parts = fixedStr.split(".");
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.length > 1 ? `${intPart}.${parts[1]}` : intPart;
    },
    formatPoints(value) {
      return this.formatThousand(value, false);
    },
    formatCash(value) {
      return this.formatThousand(value, false);
    },
    // 生成二维码
    generateQRCode() {
      // 获取商品链接
      const productLink = this.productDetail.productLink || this.productDetail.link || window.location.href;

      // 根据环境确定二维码API地址
      let qrCodeApiUrl;
      if (window.location.href.includes("https://uat.kia.cn") || this.preText.includes("uat")) {
        qrCodeApiUrl = "https://kiacarservice-uat.kia.cn/kia-carservice-api/QRCode/getQRcode";
      } else {
        qrCodeApiUrl = "https://kiacarservice.kia.cn/kia-carservice-api/QRCode/getQRcode";
      }

      // 生成二维码URL
      this.qrCodeUrl = `${qrCodeApiUrl}?url=${encodeURIComponent(productLink)}`;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #F2F2F2;
}

.container {
  min-height: 100vh;
  display: flex;
  @media (min-width: 768px) {
    padding: calc(78 / 1920 * 100vw) 0;
    width: calc(1210 / 1920 * 100vw);
    margin: 0 auto;
  }
  @media (max-width: 768px) { /* 移动端 */
    padding: 60px 0 0;
    width: 100%;
    margin: 0 auto;
  }
}

.mall-part {
  width: 100%;
  @media (min-width: 768px) {
    padding-top: calc(24 / 1920 * 100vw);
  }
  @media (max-width: 768px) {
  }
}

// 导航栏
.nav-bar {
  @media (min-width: 768px) {
  }
  @media (max-width: 768px) {
    .nav-title {
      display: none;
    }
  }
  .nav-title {
    font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
    font-size: calc(16 / 1920 * 100vw);
    line-height: calc(96 / 1920 * 100vw);
    font-weight: 500;
    color: #b9b9b9;
    cursor: pointer;
    span {
      display: inline-block;
      color: #000;
      margin-left: calc(4 / 1920 * 100vw);
      margin-right: calc(4 / 1920 * 100vw);
    }
  }
}

// 商品参数模块
.product-info-section {
  background-color: #fff;
  box-sizing: border-box;
  padding: calc(35 / 1920 * 100vw);
  @media (max-width: 768px) {
    padding: 0;
    background-color: transparent;
  }
}

.product-info-wrapper {
  display: flex;
  gap: calc(40 / 1920 * 100vw);
  @media (max-width: 768px) {
    flex-direction: column;
    gap: calc(0 / 750 * 100vw);
  }
}

// 左侧：商品图片
.product-image-section {
  flex: 0 0 auto;
  @media (min-width: 768px) {
    width: calc(672 / 1920 * 100vw);
    height: calc(672 / 1920 * 100vw);
  }
  @media (max-width: 768px) {
    width: 100%;
  }
}

.main-image {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  @media (max-width: 768px) {
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: calc(8 / 1920 * 100vw);
    object-fit: cover;
    @media (max-width: 768px) {
      border-radius: calc(8 / 750 * 100vw);
    }
  }
}

.thumbnail-list {
  display: flex;
  gap: calc(10 / 1920 * 100vw);
  overflow-x: auto;
  @media (max-width: 768px) {
    gap: calc(10 / 750 * 100vw);
  }
  &::-webkit-scrollbar {
    display: none;
  }
}

.thumbnail-item {
  flex: 0 0 auto;
  width: calc(80 / 1920 * 100vw);
  height: calc(80 / 1920 * 100vw);
  border: 2px solid transparent;
  border-radius: calc(4 / 1920 * 100vw);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  @media (max-width: 768px) {
    width: calc(80 / 750 * 100vw);
    height: calc(80 / 750 * 100vw);
    border-radius: calc(4 / 750 * 100vw);
  }
  &.active {
    border-color: #000;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// 右侧：商品信息
.product-info-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(24 / 1920 * 100vw);
  font-weight: 600;
  color: #000;
  margin: calc(22 / 1920 * 100vw) 0 calc(16 / 1920 * 100vw) 0;
  line-height: 1.4;
  @media (max-width: 768px) {
    background-color: #fff;
    font-size: calc(38 / 750 * 100vw);
    margin: 0;
    line-height: calc(147 / 750 * 100vw);
    // padding: calc(40 / 750 * 100vw) calc(70 / 750 * 100vw);
    padding-left: calc(58 / 750 * 100vw);
  }
}

.product-price-section {
  display: flex;
  gap: calc(50 / 1920 * 100vw);
  margin-bottom: calc(40 / 1920 * 100vw);
  @media (max-width: 768px) {
    height: calc(104 / 750 * 100vw);
    background-color: #fff;
    gap: calc(110 / 750 * 100vw);
    margin-top: calc(22 / 750 * 100vw);
    margin-bottom: 0;
    padding-left: calc(70 / 750 * 100vw);
  }
}

.price-item {
  display: flex;
  align-items: center;
  font-family: "FZLanTingHeiS-R-GB";
  img {
    width: calc(14 / 1920 * 100vw);
    height: auto;
    margin-right: calc(5 / 1920 * 100vw);
    @media (max-width: 768px) {
      width: calc(23 / 750 * 100vw);
      margin-right: calc(15 / 750 * 100vw);
    }
  }
  .price-label {
    font-size: calc(16 / 1920 * 100vw);
    color: #000000B2;
    @media (max-width: 768px) {
      font-size: calc(29 / 750 * 100vw);
      margin-right: calc(10 / 750 * 100vw);
    }
  }
  .price-value {
    font-size: calc(16 / 1920 * 100vw);
    color: #000000B2;
    @media (max-width: 768px) {
      font-size: calc(29 / 750 * 100vw);
    }
  }
}
.price-item:last-child {
  img {
    height: calc(15 / 1920 * 100vw);
    width: auto;
  }
  @media (max-width: 768px) {
    img {
      height: calc(26 / 750 * 100vw);
    }
  }
}

.product-spec-section {
  background-color: #fff;
  margin-bottom: calc(40 / 1920 * 100vw);
  @media (max-width: 768px) {
    margin-bottom: calc(40 / 750 * 100vw);
  }
}

.spec-item {
  margin-bottom: calc(30 / 1920 * 100vw);
  @media (max-width: 768px) {
    margin-bottom: calc(30 / 750 * 100vw);
  }
  &:last-child {
    margin-bottom: 0;
  }
}

.spec-label {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(18 / 1920 * 100vw);
  color: #333;
  margin-bottom: calc(15 / 1920 * 100vw);
  @media (max-width: 768px) {
    font-size: calc(28 / 750 * 100vw);
    margin-bottom: calc(15 / 750 * 100vw);
  }
}

.spec-options {
  display: flex;
  flex-wrap: wrap;
  gap: calc(15 / 1920 * 100vw);
  @media (max-width: 768px) {
    gap: calc(15 / 750 * 100vw);
  }
}

.spec-option {
  padding: calc(8 / 1920 * 100vw) calc(20 / 1920 * 100vw);
  border: 1px solid #ddd;
  border-radius: calc(4 / 1920 * 100vw);
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(16 / 1920 * 100vw);
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  @media (max-width: 768px) {
    padding: calc(12 / 750 * 100vw) calc(24 / 750 * 100vw);
    font-size: calc(26 / 750 * 100vw);
    border-radius: calc(4 / 750 * 100vw);
  }
  &:hover {
    border-color: #000;
  }
  &.active {
    border-color: #000;
    background-color: #000;
    color: #fff;
  }
}

.product-action {
  position: relative;
  width: calc(240 / 1920 * 100vw);
  height: calc(60 / 1920 * 100vw);
  margin-top: auto;
  @media (max-width: 768px) {
    display: none;
  }
}

.buy-btn {
  width: 100%;
  height: 100%;
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(16 / 1920 * 100vw);
  letter-spacing: calc(4 / 1920 * 100vw);
  background-color: #000;
  border-color: #000;
  position: relative;
  &:hover {
    background-color: #333;
    border-color: #333;
  }
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
}

// 二维码弹窗
.code-popup {
  position: absolute;
  bottom: calc(70 / 1920 * 100vw);
  left: 50%;
  transform: translateX(-50%);
  width: calc(238 / 1920 * 100vw);
  height: calc(256 / 1920 * 100vw);
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  @media (max-width: 768px) {
    bottom: calc(90 / 750 * 100vw);
    width: calc(238 / 750 * 100vw);
    height: calc(256 / 750 * 100vw);
  }
}

.code-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(20 / 1920 * 100vw);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding: calc(20 / 750 * 100vw);
  }
}

.code-image {
  width: calc(160 / 1920 * 100vw);
  height: calc(160 / 1920 * 100vw);
  max-width: calc(160 / 1920 * 100vw);
  max-height: calc(160 / 1920 * 100vw);
  margin-bottom: calc(15 / 1920 * 100vw);
  @media (max-width: 768px) {
    width: calc(160 / 750 * 100vw);
    height: calc(160 / 750 * 100vw);
    max-width: calc(160 / 750 * 100vw);
    max-height: calc(160 / 750 * 100vw);
    margin-bottom: calc(15 / 750 * 100vw);
  }
}

.code-text {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(14 / 1920 * 100vw);
  color: #000;
  text-align: center;
  line-height: 1.5;
  @media (max-width: 768px) {
    font-size: calc(14 / 750 * 100vw);
  }
}

// 商品详情模块
.product-detail-section {
  position: relative;
  padding-top: calc(40 / 1920 * 100vw);
  border-top: 1px solid #eee;
  @media (max-width: 768px) {
    background-color: #fff;
    margin-top: calc(22 / 750 * 100vw);
    padding: 0;
    // 给吸底按钮预留空间，避免遮挡内容
    padding-bottom: calc(20 / 750 * 100vw);
  }
}

.detail-title {
  width: 100%;
  padding-left: calc(40 / 1920 * 100vw);
  background-color: #fff;
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(19 / 1920 * 100vw);
  line-height: calc(70 / 1920 * 100vw);
  font-weight: 600;
  color: #000;
  margin-bottom: calc(20 / 1920 * 100vw);
  @media (max-width: 768px) {
    font-size: calc(29 / 750 * 100vw);
    padding-left: calc(70 / 750 * 100vw);
    padding-top: calc(30 / 750 * 100vw);
  }
}

.detail-content {
  background-color: #fff;
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(16 / 1920 * 100vw);
  color: #333;
  line-height: 1.8;
  padding: calc(40 / 1920 * 100vw);
  @media (max-width: 768px) {
    font-size: calc(28 / 750 * 100vw);
    padding: calc(30 / 750 * 100vw) calc(30 / 750 * 100vw) calc(80 / 750 * 100vw);
  }
  // 富文本内容样式
  ::v-deep img {
    display: block;
    //margin: calc(20 / 1920 * 100vw) auto;
    // 保持原始大小，不缩放
    width: auto;
    height: auto;
    @media (max-width: 768px) {
      //margin: calc(20 / 750 * 100vw) auto;
    }
  }
  ::v-deep p {
    //margin: calc(15 / 1920 * 100vw) 0;
    @media (max-width: 768px) {
      //margin: calc(15 / 750 * 100vw) 0;
    }
  }
  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5,
  ::v-deep h6 {
    font-weight: 600;
    margin: calc(20 / 1920 * 100vw) 0 calc(15 / 1920 * 100vw) 0;
    @media (max-width: 768px) {
      margin: calc(20 / 750 * 100vw) 0 calc(15 / 750 * 100vw) 0;
    }
  }
  ::v-deep ul,
  ::v-deep ol {
    padding-left: calc(30 / 1920 * 100vw);
    @media (max-width: 768px) {
      padding-left: calc(30 / 750 * 100vw);
    }
  }
  ::v-deep li {
    margin: calc(10 / 1920 * 100vw) 0;
    @media (max-width: 768px) {
      margin: calc(10 / 750 * 100vw) 0;
    }
  }
  ::v-deep table {
    width: 100%;
    border-collapse: collapse;
    margin: calc(20 / 1920 * 100vw) 0;
    @media (max-width: 768px) {
      margin: calc(20 / 750 * 100vw) 0;
      font-size: calc(24 / 750 * 100vw);
    }
  }
  ::v-deep th,
  ::v-deep td {
    border: 1px solid #ddd;
    padding: calc(10 / 1920 * 100vw);
    @media (max-width: 768px) {
      padding: calc(10 / 750 * 100vw);
    }
  }
  ::v-deep th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
}

// PC端详情右下角购买按钮
.detail-buy-btn-wrapper {
  bottom: calc(40 / 1920 * 100vw);
  right: calc(40 / 1920 * 100vw);
  z-index: 99;
  @media (max-width: 768px) {
    z-index: 99;
    width: 100%;
    box-sizing: border-box;
    padding: calc(10 / 750 * 100vw) calc(30 / 750 * 100vw) ;
    background-color: #fff;
    // border-top: 1px solid #E8E8E8;
  }
}

@media (max-width: 768px) {
  // Footer 进入视口后：按钮回到详情区域底部
  .detail-buy-btn-wrapper.detail-buy-btn-wrapper--absolute {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

// 移动端吸底悬浮（JS 判断，避免依赖 viewport meta 导致媒体查询失效）
.detail-buy-btn-wrapper.detail-buy-btn-wrapper--fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  padding: calc(10 / 750 * 100vw) calc(30 / 750 * 100vw);
  background-color: #fff;
}

// 移动端到位停靠（JS 判断）
.detail-buy-btn-wrapper.detail-buy-btn-wrapper--absolute {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.detail-product-action {
  position: relative;
  display: flex;
    justify-content: flex-end;
    padding-top: calc(30 / 1920 * 100vw);
  @media (max-width: 768px) {
    width: 100%;
    padding-top: 0;
    justify-content: space-between;
    align-items: center;
  }
}

.detail-back-btn {
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: calc(135 / 750 * 100vw);
    height: calc(100 / 750 * 100vw);
    font-size: calc(30 / 750 * 100vw);
    border-radius: calc(4 / 750 * 100vw);
    color: #000;
    background-color: #EFEFEF;
    padding: 0;
    border: none;
    i {
      font-size: calc(50 / 750 * 100vw);
      line-height: 1;
      color: #00000069;
    }
  }
}

.detail-buy-btn {
  width: calc(240 / 1920 * 100vw);
  height: calc(60 / 1920 * 100vw);
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(16 / 1920 * 100vw);
  letter-spacing: calc(4 / 1920 * 100vw);
  background-color: #000;
  border-color: #000;
  &:hover {
    background-color: #333;
    border-color: #333;
  }
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: calc(65 / 750 * 100vw);
    font-size: calc(23 / 750 * 100vw);
  }
}

// 详情按钮的二维码弹窗
.detail-code-popup {
  position: absolute;
  bottom: calc(70 / 1920 * 100vw);
  right: 0;
  width: calc(238 / 1920 * 100vw);
  height: calc(256 / 1920 * 100vw);
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.detail-code-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(20 / 1920 * 100vw);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.detail-code-image {
  width: calc(160 / 1920 * 100vw);
  height: calc(160 / 1920 * 100vw);
  max-width: calc(160 / 1920 * 100vw);
  max-height: calc(160 / 1920 * 100vw);
  margin-bottom: calc(15 / 1920 * 100vw);
}

.detail-code-text {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(14 / 1920 * 100vw);
  color: #000;
  text-align: center;
  line-height: 1.5;
}
</style>
